module.exports = __webpack_public_path__ + "img/icon-audit.108e5285.svg";